import { Prose } from './Prose';

export type { TypeProseProps } from './types';
export default Prose;
